import { render, staticRenderFns } from "./CsrDonationChallenge.vue?vue&type=template&id=2bd9d272&scoped=true"
import script from "./CsrDonationChallenge.vue?vue&type=script&lang=js"
export * from "./CsrDonationChallenge.vue?vue&type=script&lang=js"
import style0 from "./CsrDonationChallenge.vue?vue&type=style&index=0&id=2bd9d272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9d272",
  null
  
)

export default component.exports